import { mapMutations, mapGetters, mapActions } from "vuex";
import { minLength, required, maxLength } from "vuelidate/lib/validators";

export default {
    name: "enter-form-phone",
    props: ["phone"],
    data() {
        return {
            payload: {
                code: "",
            },
            validationErrors: {},
            step: "2",
        };
    },
    validations: {
        payload: {
            code: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6),
            },
        },
    },
    components: {},
    computed: {
        ...mapGetters({
            singInLoading: "auth/singInPhoneLoading",
            sendCodeLoading: "auth/sendCodeLoading",
            popupRegister: "auth/popupRegister",
            favouriteList: "favorites/whichList",
        }),
        codeErrors() {
            let error = [];
            if (!this.$v.payload.code.$dirty) {
                return error;
            }
            if (!this.$v.payload.code.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.code.minLength) {
                error.push(this.$t("validationMin") + " 6");
            }
            if (!this.$v.payload.code.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (this.validationErrors.code) {
                this.validationErrors.code.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.code === "") {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            singIn: `auth/GET_TOKEN_PHONE`,
            sendCode: `auth/SEND_CODE_PHONE`,
            fetchUser: `profile/FETCH_USER_DATA`,
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
        }),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.code = this.payload.code;
            obj.phone = this.phone.replace(/[\s.,%()-]/g, "");
            if (!this.$v.$invalid) {
                this.singIn(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("successAuth"));
                        const route = this.$router.resolve({ name: "profile" });
                        window.location.href = `${window.location.origin}${route.href}`;

                        if (this.popupRegister.isRedirect) {

                            // this.$router.push({ name: "profile" }).catch(() => {
                            //     this.fetchUser();
                            //     this.fetchFavouriteList();
                            // });
                        }
                        this.changePopupRegister(false);
                    })
                    .catch(error => {
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.message);
                        }
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                        }
                    });
            }
        },
    },
};
